import {
  HttpClient,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AuthService } from "app/auth/auth.service";
import { LoadingController, ToastController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { ConfigurationService } from "../configuration/configuration.service";
import { StateManagementService } from "../state-management/state-management.service";

@Injectable()
export class ManualPaymentDataService {
  spinner = null;
  spinnerCounter = 0;
  dataUrl: string;

  constructor(
    private authSvc: AuthService,
    public http: HttpClient,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public stateData: StateManagementService,
    private config: ConfigurationService
  ) {
    this.dataUrl = config.getConfig().billingUrl;
  }

  ngOnDestroy() {}

  getPayers() {
    const user = this.authSvc.getUser();
    if (user) {
      return new Observable((observer) => {
        this.increaseSpinnerCount();
        this.http.get(`${this.dataUrl}/payers/`).subscribe(
          (data) => {
            this.decreaseSpinnerCount();
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            this.presentErrorToast(err, "Failed to load data.");
            this.decreaseSpinnerCount();
            observer.error(err);
            observer.complete();
          }
        );
      });
    }
  }

  getHeaderData(rANumber, payer) {
    return new Observable((observer) => {
      this.increaseSpinnerCount();
      this.http
        .get(`${this.dataUrl}/remittanceadvice/${rANumber}/${payer.id}`)
        .subscribe(
          (data) => {
            this.decreaseSpinnerCount();
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            this.decreaseSpinnerCount();
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  getReasonCodes(payer) {
    return new Observable((observer) => {
      this.increaseSpinnerCount();
      this.http
        .get(`${this.dataUrl}/payers/${payer.id}/adjustmentreasoncodes`)
        .subscribe(
          (data) => {
            this.decreaseSpinnerCount();
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            this.presentErrorToast(err, "Failed to load data.");
            this.decreaseSpinnerCount();
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  getClaim(payer, claim) {
    return new Observable((observer) => {
      this.increaseSpinnerCount();
      this.http
        .get(`${this.dataUrl}/claims/${claim.id}?payerId=${payer.id}`)
        .subscribe(
          (data) => {
            this.decreaseSpinnerCount();
            observer.next(data);
            observer.complete();
          },
          (err: HttpErrorResponse) => {
            if (err.status === 404) {
            } else {
              this.presentErrorToast(err, "Failed to load data.");
            }
            this.decreaseSpinnerCount();
            observer.error(err);
            observer.complete();
          }
        );
    });
  }

  postRecord(data): Observable<any> {
    const user = this.authSvc.getUser();
    let headers = new HttpHeaders().set("Content-Type", "application/json");
    if (user) {
      let url: string = `${this.dataUrl}/remittanceadvice`;
      return new Observable((observer) => {
        this.increaseSpinnerCount("Saving...");
        this.http.post(url, data, { headers: headers }).subscribe(
          (data) => {
            this.presentSuccessToast(
              "Successfully saved Payment Processing data."
            );
            observer.next(data);
            observer.complete();
            this.decreaseSpinnerCount();
          },
          (err) => {
            this.presentErrorToast(err, "Failed to store data.");
            this.decreaseSpinnerCount();
            observer.error(err);
            observer.complete();
          }
        );
      });
    }
  }

  presentSuccessToast(message: string) {
    let toast = this.toastCtrl.create({
      message: message,
      duration: 3000,
      position: "below",
      cssClass: "success",
    });

    toast.present();
  }

  presentErrorToast(err: HttpErrorResponse, message: string) {
    if (err && (err as any).code === "REFRESH_TOKEN_FAILED") {
      return;
    }
    message += " ";
    if (err.error instanceof Error) {
      message += "Client error.";
    } else {
      message += " ";
      if (err.status == 401) {
        message += "User not authorized.";
      } else if (err.status >= 500) {
        message += "Server error.";
      } else {
        message += "Communication error.";
      }
    }

    let toast = this.toastCtrl.create({
      message: message,
      duration: 4000,
      position: "below",
      cssClass: "error",
    });

    toast.present();
  }

  increaseSpinnerCount(message: string = "Loading data...") {
    this.spinnerCounter++;
    if (this.spinnerCounter && this.spinner == null) {
      this.spinner = this.loadingCtrl.create({
        content: message,
      });
      this.spinner.present();
    }
  }

  decreaseSpinnerCount() {
    this.spinnerCounter--;
    if (this.spinnerCounter <= 0) {
      this.spinner.dismiss();
      this.spinner = null;
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/billing-data-service/manual-payment-data-service.ts